import { clearStoredLogin } from './AuthStorageService';

export const dbFatalErrorEventName = 'onDbServiceFatalError';

export type DbFatalErrorEventDetail = {
    code: string;
    error?: unknown;
};

export const getDbErrorHttpStatus = (error: unknown): number | undefined => {
    if (typeof error !== 'object' || error === null) {
        return undefined;
    }

    const status = (error as { status?: unknown }).status;
    return typeof status === 'number' ? status : undefined;
};

let fatalErrorDispatched = false;

export const resetFatalDbErrorDispatch = (): void => {
    fatalErrorDispatched = false;
};

export const dispatchFatalDbError = (code: string, error?: unknown): void => {
    if (fatalErrorDispatched) {
        return;
    }

    fatalErrorDispatched = true;
    console.error(`[DbService fatal error] ${code}`, error);
    clearStoredLogin();
    document.dispatchEvent(new CustomEvent<DbFatalErrorEventDetail>(dbFatalErrorEventName, {
        detail: { code, error }
    }));
};
